module.exports = __webpack_public_path__ + "img/client_icn.ae70f00f.svg";